import { CarrierDeliveryProposalCreatePage } from "@/pages/carrier-delivery-proposal-create";
import { createFileRoute, useParams } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth_requeired/carrier/cargos/$id/delivery-proposals/create",
)({
  component: () => {
    const { id } = useParams({ strict: false });
    return <CarrierDeliveryProposalCreatePage offerCargoIdStr={id} />;
  },
});
